import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Observable } from 'rxjs';

import { FooterBusinessComponent } from './components/footer-business/footer-business.component';
import { FooterPlatformComponent } from './components/footer-platform/footer-platform.component';

import { MainNavService } from '../shared/core/header/services/main-nav.service';

@Component({
  selector: 'sh-footer',
  imports: [
    CommonModule,
    FooterBusinessComponent,
    FooterPlatformComponent
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  providers: [MainNavService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  isPlatform$: Observable<boolean> = this._mainNavService.isPlatform$;
  canShowFooter$: Observable<boolean> = this._mainNavService.checkIfCanShowFooter();

  constructor(private _mainNavService: MainNavService) {}
}
